import {XauditModel} from '../../../models/xaudit.model';


// tslint:disable:variable-name

export class DataPatientCaseEndoRecallModel extends XauditModel {
  CaseRecallID: string;
  PatientCaseId: string;
  CaseFinalReportID: string;
  CaseWorkItemFormsId: string;
  enumEndoRecallInTimeID: string;
  for_enumEndoRecallInTimeID: string;
  enumEndoRecallToothResoredID: string;
  enumEndoRecallCoronalLeakID: string;
  enumEndoRecallAsymFuncID: string;
  enumEndoRecallLucencyID: string;
  enumEndoRecallPDLID: string;
  enumEndoRecallPalpSoreID: string;
  enumEndoRecallPercussID: string;
  enumEndoRecallMobilityID: string;
  enumEndoRecallSinusTrackID: string;
  probingM_enumProbingDepthID: string;
  probingMB_enumProbingDepthID: string;
  probingB_enumProbingDepthID: string;
  probingDB_enumProbingDepthID: string;
  probingML_enumProbingDepthID: string;
  probingL_enumProbingDepthID: string;
  probingDL_enumProbingDepthID: string;
  probingD_enumProbingDepthID: string;
  enumEndoRecallCurrentFindingID: string;
  isSendRecallReport: boolean;
  isRecallReportSent: boolean;
  RecallReportSentOn: Date;
  RecallReportSentBy: string;
  ActualRecallDate: Date;
  for_RecallDate: Date;
}
